import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import { Collapse } from 'reactstrap';
import Actions from '../../../appFlux/action'
import { SelectDD , ExternalDD } from '../../../common/dropdowns';
import { remunerationBands , currencyList } from '../../../appConstants'

const EditMyRemuModal = ({ modal, toggle, remuneration }) => {
    const [band, setBand] = useState(remuneration.band);
    const [currency, setCurrency] = useState(remuneration.currency);

    const reset = () => {
      setBand(remuneration.band)
      setCurrency(remuneration.currency)
    }
    const save = () => {
      Actions.setRemuneration({band, currency})
      toggle()
    }

    var selectedRemuneration = remunerationBands.filter(o => o.value == band)[0]
    var selectedCurrency = currencyList.filter(o => o.value == currency)[0]

    return (
    <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-850">        
        <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
            <div className="modal-header">Edit Current Remuneration</div>
            <div className="v-align f-right" style={{marginLeft:'auto'}}>
                <i className="fa fa-cog modal-close mg-r-15" ></i> 
                <i className="far fa-question-circle modal-close mg-r-15" ></i>
                <i className="fas fa-times modal-close" onClick={toggle}></i>
            </div>
        </div>   
        <hr className="mg-r-0"></hr>
        
        <div className="modal-block">
            <div className="row mg-b-15">
                <div className="col-md-6">
                    <div className="modal-subheader">Currency</div>
                    <SelectDD data={currencyList} onChange={(o) => setCurrency(o.value)} selected={selectedCurrency} isClearable={false} />
                </div>
                <div className="col-md-6">
                    <div className="modal-subheader">Current Remuneration Band</div>
                    <SelectDD data={remunerationBands} onChange={(o) => setBand(o.value)} selected={selectedRemuneration} isClearable={false} />
                </div>
            </div>
        </div> 
        <hr className="mg-0 "></hr>
        <div className="pd-20 box-shadow-top">
            <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>             
            <button className="btn btn-primary-lite f-right mg-r-15" onClick={save}>Save</button>
            <button className="btn btn-success-lite mg-r-15 f-right" onClick={reset}>Reset</button>            
        </div>
        </Modal>          
    
)}
export default EditMyRemuModal;